import React, { useState } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';
import stringReplace from 'react-string-replace';

import Image from 'components/Image';

import imgTriider from 'assets/img/icons/triider.jpg';
import imgInfo from 'assets/img/icons/info.svg';
import calendar from 'assets/img/icons/calendar.svg'

import { moneyBrRegex } from 'utils/regex';

import { colors } from 'stylesheets'

import {
  MessageCard,
  TextWrapper,
  UserName,
  MessageText,
  MessageTextColor,
  ChangeDate,
  MessageInfo,
  MessageHour,
  MessageStatus,
  BlockedContent,
  MessageHeader,
  TimeHeader
} from './styles';

const getText = (message) => {
  if (message.is_system) {
    return stringReplace(message.text, moneyBrRegex, match => (
      <strong key={`${message.id}-text`}>{match}</strong>
    ));
  }
  return message.text;
};

const checkArray = (messages, currentMessage) => {
  const _current = messages.sort( (a,b) => new Date(b.time) - new Date(a.time) )
  .filter(message => message.system_key === 'task_scheduled' || message.system_key === 'task_schedule_confirmed')[0]

  return _current.id === currentMessage.id
}

const SystemWrapper = ({ onInfoClick, children, time, currentMessage, messages }) => {
  let _message = true

  if(messages) {
    _message = checkArray(messages, currentMessage)
  }

  return (
    <MessageCard isSystem last={_message}>
      <TextWrapper isSystem>
        <MessageHeader>
          <Image size="xsmall" rounded={time ? false : true} src={time ? calendar : imgTriider} alt="Triider" />
          {!!onInfoClick && (
            <Image
              onClick={onInfoClick}
              isLink
              size="xxsmall"
              rounded
              src={imgInfo}
              alt="Mais Informações"
            />
          )}
          {time && (
            <TimeHeader>{time}</TimeHeader>
          )}
        </MessageHeader>
        {children}
      </TextWrapper>
    </MessageCard>
  );
}

const Message = ({
  taskDetail,
  message,
  isUser,
  hasNewAmountComment,
  onClick,
  isCompany,
  setHireModalIsOpen,
  messages
}) => {

  const handleDate = (currentMessage) => {
    const _message = checkArray(messages, currentMessage)
    if(_message && (taskDetail.status === 'open' || taskDetail.status === 'hired') ) setHireModalIsOpen(true)
  }

  switch (message.system_key) {
    case 'blocked':
      return (
        <SystemWrapper onInfoClick={() => onClick(message.system_key)} >
          <BlockedContent>Conteúdo bloqueado</BlockedContent>
        </SystemWrapper>
      );
    case 'quote_close':
      return (
        <SystemWrapper>
          <MessageText>Negócio fechado com outro prestador.</MessageText>
        </SystemWrapper>
      );
    case 'pro_hired':
      return (
        <SystemWrapper>
          <MessageText>
            Você contratou esse profissional! Não esqueça de marcar o dia e horário do atendimento por aqui!
          </MessageText>
        </SystemWrapper>
      );
    case 'task_scheduled':
      return (
        <SystemWrapper time={message.text} messages={messages} currentMessage={message}>
          <MessageText>
            O profissional ainda <MessageTextColor color={colors.primary}>não confirmou</MessageTextColor> o agendamento.
          </MessageText>
          <ChangeDate last={checkArray(messages, message) && (taskDetail.status === 'open' || taskDetail.status === 'hired')} onClick={() => handleDate(message)}>EDITAR DATA</ChangeDate>
        </SystemWrapper>
      );
    case 'task_schedule_confirmed':
      return (
        <SystemWrapper time={message.text}>
          <MessageText>
            O profissional <MessageTextColor color={"mediumseagreen"}>confirmou</MessageTextColor> o agendamento.
          </MessageText>
        </SystemWrapper>
      );
    case 'task_schedule_canceled':
    return (
      <SystemWrapper time={message.text}>
        <MessageText>
          O profissional <MessageTextColor color={colors.danger}>cancelou</MessageTextColor> o agendamento.
        </MessageText>
      </SystemWrapper>
    );
    default:
      return (
        <MessageCard last isUser={isCompany}>
          <TextWrapper isUser={isCompany}>
            <MessageHeader>
              <UserName>{message.user_name}</UserName>
              {message.system_key === 'quote_charged_new' && hasNewAmountComment && (
                <Image
                  onClick={() => onClick(message.system_key)}
                  isLink
                  size="xxsmall"
                  rounded
                  src={imgInfo}
                  alt="Mais Informações"
                />
              )}
            </MessageHeader>
            <MessageText>{getText(message)}</MessageText>
          </TextWrapper>
          <MessageInfo>
            <MessageHour>{moment(message.time).format('HH:mm')}</MessageHour>
            {isCompany && <MessageStatus isRead={message.is_read} />}
          </MessageInfo>
        </MessageCard>
      );
  }
};
/*
quote_sent
quote_charged_new
quote_accept
blocked
false
quote_charged
*/


const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
})

export default connect(
  mapStateToProps
)(Message);
